import { Injectable } from '@angular/core';
import Serial from './../../app/plugins/serial';
import { SharedPluginListener } from '../helpers/hardware/shared-plugin-listener.helper';

@Injectable({
  providedIn: 'root'
})
export class ScaleProvider {
  private readonly listener = new SharedPluginListener<any>({
    tag: '[ScaleProvider]',
    registerListeners: async (emit) => {
      await Serial.addListener(
        'serialPluginLogEvent',
        this.handleSerialLogEvent
      );
      await Serial.addListener('scaleWeightEvent', emit);
    },
    start: () => Serial.initialize(),
    stop: () => Serial.stop()
  });

  /**
   * Start receiving scale weights. Rejects if the scale could not be started. The scale stays connected while
   * at least one subscription is open; unsubscribe the returned Subscription when the consumer is destroyed.
   */
  async startListener(handleScaleWeight: (info: any) => void) {
    const subscription = this.listener.subscribe(handleScaleWeight);
    try {
      await this.listener.ready;
    } catch (error) {
      subscription.unsubscribe();
      throw error;
    }
    // use for simulate the scale event on the browser
    // interval(500).subscribe(() => {
    //   handleScaleWeight({ new_weight: '0.453lb' });
    // });
    return subscription;
  }

  handleSerialLogEvent(event) {
    console.log('Handle Serial Log Event: ', event.data);
  }
}
